import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpContext } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ApiResponse, USE_ALL_SITES } from '@card-software/nexus-utilities';
import { Certification } from '../../models/certification';

@Injectable({
  providedIn: 'root',
})
export class CertificationProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/certification';

  getAllCertifications(useAllSites = false): Observable<ApiResponse<Certification[]>> {
    const context = new HttpContext().set(USE_ALL_SITES, useAllSites);
    return this.httpClient.get<ApiResponse<Certification[]>>(`${this.baseUrl}/all`, { context });
  }
}
